<template>
  <div
    class="modal fade confirmationOfCancellation-modal"
    tabindex="-1"
    aria-labelledby="confirmationOfCancellationModalLabel"
    aria-hidden="true"
    ref="confirmationOfCancellationModal"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="closeButton"
          ></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label"
              >Вы подтверждаете отмену автоплатежа?</label
            >
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="onYes">
            Да
          </button>
          <button type="button" class="btn btn-primary" @click="onNo">
            Нет
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref } from "vue";
// import { useRouter } from "vue-router";
import { Modal } from "bootstrap";

export default defineComponent({
  name: "ConfirmationOfCancellationModal",
  emits: ["confirm"],
  setup(props, { emit }) {
    const confirmationOfCancellationModal = ref(null);
    // const emit = defineEmits(["confirm"]);
    let modalInstance = null;

    const openModal = () => {
      if (modalInstance) {
        modalInstance.show();
      }
    };

    const closeModal = () => {
      if (modalInstance) {
        modalInstance.hide();
      }
    };

    const onYes = () => {
      emit("confirm");
      closeModal();
    };

    const onNo = () => {
      closeModal();
    };

    onMounted(() => {
      if (confirmationOfCancellationModal.value) {
        modalInstance = Modal.getOrCreateInstance(
          confirmationOfCancellationModal.value
        );
      } else {
        console.error("Модальное окно не найдено");
      }
    });

    return {
      openModal,
      closeModal,
      confirmationOfCancellationModal,
      onYes,
      onNo,
    };
  },
});
</script>

<style scoped lang="scss">
.form-label {
  display: flex;
  justify-content: center;
}

.modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
  padding: 20px 50px;
}

.modal-footer .btn {
  flex: 1;
  padding: 6px 0;
  font-size: 14px;
  font-weight: 700;
}
</style>
